import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  bcpSharedModelService,
  ssDialogService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
  importDocument,
} from 'app/components/global';

import editServerDialog from './dialog.editServerDialog';
import deleteServersDialog from './dialog.deleteServersDialog';
import controller from './servers.controller';
import directive from './servers.directive';
import server from './server';


export default angular.module('app.components.advisory.bcp.servers', [
  alerts,
  bcpDataService,
  bcpSharedModelService,
  confirmDialog,
  constants,
  editServerDialog,
  deleteServersDialog,
  importDocument,
  ssDialogService,
  server,
])
  .directive('bcpServers', directive)
  .controller('ServersController', controller)
  .name;

console.log('app.components.advisory.bcp.servers created');
